/* eslint-disable @typescript-eslint/camelcase */
import { FormClientUser } from 'modules/clients/interfaces';

export const initialValues: FormClientUser = {
  first_name: '',
  last_name: '',
  email: '',
  fictitious_email: false,
  ad_password_salt: { skip: true, skip_reason: '', salt: '' },
  userAd: '',
  profile_path: '',
  use_profile: false,
};
